import { createTheme } from '@material-ui/core/styles';
import styles from 'assets/styles/default.scss';

const primaryColor = {
  50: styles.primaryColor50,
  100: styles.primaryColor100,
  200: styles.primaryColor200,
  300: styles.primaryColor300,
  400: styles.primaryColor400,
  500: styles.primaryColor500,
  600: styles.primaryColor600,
  700: styles.primaryColor700,
  800: styles.primaryColor800,
  900: styles.primaryColor900,
  A100: styles.primaryColorA100,
  A200: styles.primaryColorA200,
  A400: styles.primaryColorA400,
  A700: styles.primaryColorA700,
  contrastDefaultColor: styles.primaryColorContrastDefaultColor,
};
const secondaryColor = {
  50: styles.secondaryColor50,
  100: styles.secondaryColor100,
  200: styles.secondaryColor200,
  300: styles.secondaryColor300,
  400: styles.secondaryColor400,
  500: styles.secondaryColor500,
  600: styles.secondaryColor600,
  700: styles.secondaryColor700,
  800: styles.secondaryColor800,
  900: styles.secondaryColor900,
  A100: styles.secondaryColorA100,
  A200: styles.secondaryColorA200,
  A400: styles.secondaryColorA400,
  A700: styles.secondaryColorA700,
  contrastDefaultColor: styles.secondaryColorContrastDefaultColor,
};

export const LayoutMuiTheme = createTheme({
  typography: {
    fontFamily: '"Nunito", sans-serif',
  },
  palette: {
    primary: primaryColor,
    secondary: secondaryColor,
  },
  overrides: {
    MuiAppBar: {
      colorDefault: {
        backgroundColor: '#F00',
      },
    },
    MuiCard: {
      root: {
        padding: 8,
        overflow: 'initial',
      },
    },
    MuiExpansionPanelSummary: {
      root: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        borderBottomColor: styles.secondarySicrediLight,
        borderBottomStyle: 'solid',
        borderBottomWidth: 1,
        minHeight: 40,
        padding: '0 16px',
        '&.Mui-expanded': {
          minHeight: 40,
        },
        '&.Mui-disabled': {
          opacity: 1,
        },
      },
      expandIcon: {
        fontSize: 16,
        padding: 8,
        order: 2,
      },
      content: {
        margin: 0,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        order: 1,
        '&.Mui-expanded': {
          margin: 0,
        },
      },
    },
    MuiExpansionPanel: {
      root: {
        margin: '16px 0',
      },
      rounded: {
        borderRadius: 4,
      },
    },
    MuiExpansionPanelDetails: {
      root: {
        padding: 16,
      },
    },
    MuiExpansionPanelActions: {
      root: {
        padding: '0 16px 14px',
        '@media (max-width: 768px)': {
          flexDirection: 'column',
        },
      },
    },
    MuiChip: {
      root: {
        height: '28px',
        borderRadius: '15px',
        backgroundColor: styles.secondarySicrediLight,
        color: styles.primarySicrediDarker,
        '&$disabled': {
          opacity: 1,
        },
      },
      label: {
        fontFamily: '"Nunito", sans-serif',
        fontSize: 16,
        fontWeight: 300,
        lineHeight: '24px',
      },
      icon: {
        width: 16,
        height: 16,
      },
      iconColorPrimary: {
        color: styles.primarySicredi,
      },
      colorPrimary: {
        backgroundColor: styles.primarySicrediLight,
        color: styles.primarySicrediDarker,
        '&$disabled': {
          backgroundColor: styles.secondarySicrediLight,
          color: styles.secondarySicrediDarker,
        },
      },
      colorSecondary: {
        backgroundColor: styles.dangerSicrediLight,
        color: styles.dangerSicrediDark,
        '&$disabled': {
          backgroundColor: styles.secondarySicrediLight,
          color: styles.secondarySicrediDarker,
        },
      },
    },
    MuiRadio: {
      root: {
        color: styles.primarySicredi + ' !important',
        fontFamily: '"Nunito" !important',
        '&$checked': {
          color: styles.primarySicredi + ' !important',
        },
        '&$disabled': {
          color: styles.secondarySicredi + ' !important',
        },
        '&&MuiTypography-root': {
          fontFamily: '"Nunito"',
        },
      },
    },
    MuiButton: {
      root: {
        borderRadius: '8px !important',
        padding: '0 !important',
        boxShadow: 'none !important',
        minHeight: '28px',
      },
      startIcon: {
        marginLeft: '0',
        marginRight: '8px',
      },
      endIcon: {
        marginLeft: '8px',
        marginRight: '0',
      },
      iconSizeMedium: {
        '& > *:first-child': {
          fontSize: 16,
        },
      },
      label: {
        fontFamily: '"Nunito"',
        fontWeight: 300,
        fontSize: '16px !important',
        lineHeight: '24px !important',
        textTransform: 'none',
        padding: '2px 8px !important',
      },
    },
    MuiBadge: {
      badge: {
        zIndex: 'initial',
      },
    },
    MuiSelect: {
      root: {
        zIndex: 3,
      },
    },
    MuiFormLabel: {
      root: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '90%',
        lineHeight: '1.3em',
        '&&Mui-focused': {
          maxWidth: '130%',
        },
        '&.Mui-focused': {
          maxWidth: '130%',
        },
      },
      filled: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '130%',
      },
    },
    MuiTooltip: {
      tooltip: {
        fontFamily: '"Nunito", sans-serif',
        fontSize: 14,
      },
    },
  },
});
